/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { blankEnumSchema } from "./blankEnumSchema.ts";
import { nullEnumSchema } from "./nullEnumSchema.ts";
import { orderPaymentMethodEnumSchema } from "./orderPaymentMethodEnumSchema.ts";
import { status4B4EnumSchema } from "./status4B4EnumSchema.ts";
import { workModeEnumSchema } from "./workModeEnumSchema.ts";

export const mobileOrderResponseSchema = z.object({
	id: z.uuid(),
	created_at: z.iso.datetime(),
	external_id: z.uuid().nullish(),
	status: status4B4EnumSchema
		.optional()
		.describe(
			"* `created` - Создан локально\n* `waiting_payment` - Ожидает оплаты\n* `waiting_deferred_payment` - Ожидает отложенной оплаты\n* `partial_paid` - Частично оплачен\n* `paid` - Оплачен\n* `failed_payment` - Ошибка оплаты\n* `failed_after_paid` - Ошибка после оплаты\n* `waiting_creation_iiko` - Ожидает создания в iiko\n* `failed` - Ошибка\n* `sent` - Создан в iiko\n* `confirmed` - Подтвержден пользователем\n* `failed_after_sent` - Ошибка создания в iiko\n* `waiting_for_fiscalization` - Ожидает фискализации\n* `sent_fiscalization` - Отправлен на фискализацию\n* `failed_after_sent_fiscalization` - Ошибка после отправки на фискализацию\n* `fake_fiscalized` - Фейковая временная фискализация без явно отправки на фискализацию (для режимов PSN и DESTROYER)\n* `fiscalized` - Фискализирован, ожидает оплаты или отправки на инициализацию оплаты\n* `payment_initiation` - Инициирована оплата\n* `payment_initiation_retry` - Повторная инициация оплаты\n* `failed_after_payment_initiation` - Ошибка после инициации оплаты\n* `waiting_for_refund` - Ожидает возврата\n* `refunded` - Возвращен\n* `refund_failed` - Ошибка возврата\n* `waiting_manual_action` - Ожидает ручного действия персонала\n* `completed` - Заказ завершен\n* `cancelled` - Заказ отменен",
		),
	total_cost: z.number().nullish(),
	paid_by_bonuses: z.number().optional(),
	work_mode: z.union([workModeEnumSchema, blankEnumSchema, nullEnumSchema]).nullish(),
	order_payment_method: z
		.union([orderPaymentMethodEnumSchema, blankEnumSchema, nullEnumSchema])
		.nullish()
		.describe(
			"Заполняется только для заказов в режиме Ресторан (ТС); для остальных — null.\n\n* `PARTIAL` - Разрешить частичную оплату\n* `FULL_ONLY` - Разрешить только полную оплату\n* `DISABLED` - Запретить оплату",
		),
	locator: z.string().max(8).nullish(),
	comment: z.string().max(50).nullish(),
	error_code: z.int().min(-2147483648).max(2147483647).nullish(),
	error_message: z.string().nullish(),
	out_of_stock_info: z
		.any()
		.nullish()
		.describe(
			"Что касса ответила по стоп-листу, когда отказалась принять заказ: какие позиции недоступны, сколько их осталось и текст для гостя. Нужно, чтобы показать причину отказа, даже если фронт подключился к заказу уже после ответа кассы.",
		),
	history_status: z.any().optional(),
	applied_rms_discount: z.boolean().optional(),
	has_mark: z.boolean().optional(),
	has_plugin_simple_mark: z.boolean().optional(),
	forced_send_order_to_kitchen: z.boolean().optional(),
	sent_order_to_kitchen: z.boolean().optional(),
	delivery_cost: z
		.string()
		.regex(/^-?\d{0,8}(?:\.\d{0,2})?$/)
		.nullish(),
	vat_rate: z.number().nullish(),
	applied_promocode: z.string().nullish(),
	plugin_task_id: z.uuid().nullish(),
	org_unit: z.uuid(),
	plugin_order: z.uuid().nullish(),
	device: z.uuid().nullish().describe("Устройство, с которого был создан заказ"),
	order_type: z.uuid().nullish().describe("Выбранный тип заказа"),
	table: z.uuid().nullish(),
	subscription: z.uuid().nullish(),
	user: z.array(z.uuid()).optional(),
});
